import { Button } from "@/components/ui/button";
import { NavLink } from "@/components/NavLink";
import { ArrowRight, Phone } from "lucide-react";

interface BottomCTAProps {
  headline?: string;
  subheadline?: string;
}

export const BottomCTA = ({ 
  headline = "Ready to Turn Your Website Into a Lead Machine?",
  subheadline = "Let's discuss your lawn care or landscaping business and create a website that actually brings in clients."
}: BottomCTAProps) => {
  return (
    <section className="py-16 bg-primary text-primary-foreground">
      <div className="container px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold">{headline}</h2>
          <p className="text-lg opacity-90">{subheadline}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="#get-started">
              <Button size="lg" variant="secondary" className="gap-2">
                <Phone className="h-4 w-4" />
                Get Started
              </Button>
            </a>
            <NavLink to="/contact/">
              <Button size="lg" variant="outline" className="gap-2 border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary">
                Contact Us
                <ArrowRight className="h-4 w-4" />
              </Button>
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
};
